export enum PropertyPricingType {
  EARLY_BIRD_DISCOUNT = 'EARLY_BIRD_DISCOUNT',
  LAST_MINUTE_DISCOUNT = 'LAST_MINUTE_DISCOUNT',
  LOS_DISCOUNT = 'LOS_DISCOUNT',
  SHORT_STAY_PREMIUM = 'SHORT_STAY_PREMIUM',
}
